import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import { AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DEFAULT } from '../virtual-clinic.const';
import { BdResourcesSelectInlineConfig } from '@bindoc-projects/resource-lib/data';
import { BdResourcesSelectInlineSingleComponent } from '@bindoc-projects/resource-lib/ui';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

@Component({
  selector: 'ays-virtual-clinic-select-inline',
  template: `
      <bd-resources-select-inline-single
        [resourceSelect]="resourceSelect()"
        [resourceName]="shareableType()"
        [config]="options()"
        (resourceSelectChange)="onVirtualClinicSelect($event)"
      >
      </bd-resources-select-inline-single>
    `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BdResourcesSelectInlineSingleComponent],
})
export class AysVirtualClinicSelectInlineComponent {
  readonly virtualClinicId = input<string | undefined>(undefined);
  readonly options = input<BdResourcesSelectInlineConfig<AysVirtualClinic>>(
    AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DEFAULT,
  );
  readonly shareableType = input<ShareableType>(ShareableType.VIRTUAL_CLINIC);
  readonly virtualClinicSelect = output<AysVirtualClinic | null>();

  readonly resourceSelect = signal<{
    id: string;
    resource?: AysVirtualClinic;
  } | null>(null);

  constructor() {
    effect(() => {
      const virtualClinicId = this.virtualClinicId();
      if (virtualClinicId) {
        this.resourceSelect.set({ id: virtualClinicId });
      }
    });
  }

  public onVirtualClinicSelect(
    virtualClinicSelect: { id: string; resource?: AysVirtualClinic } | null,
  ) {
    this.virtualClinicSelect.emit(virtualClinicSelect?.resource);
  }
}
